"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IfLoggedInUser = void 0;
var _useToken = require("./useToken");
var IfLoggedInUser = function(param) {
    var children = param.children;
    var isAnonymousUser = (0, _useToken.useToken)().isAnonymousUser;
    if (isAnonymousUser) {
        return null;
    }
    return children;
};
exports.IfLoggedInUser = IfLoggedInUser; //# sourceMappingURL=IfLoggedInUser.js.map
